<template>
  <div class="container">
    <div>
      <p>統籌執行</p>
      <p :style="{ height: producerHeight }">製作人</p>
      <p :style="{ height: reporterHeight }">採訪記者</p>
      <p :style="{ height: imageHeight }">影像</p>
      <p>視覺設計</p>
      <p>工程師</p>
      <p class="blank"></p>
      <p>協力團隊</p>
      <p class="blank"></p>
      <p class="blank"></p>
      <p class="blank"></p>
      <p class="blank"></p>
      <p class="blank"></p>
      <p class="blank"></p>
      <p>監製</p>
      <p>顧問</p>
      <p>製作單位</p>
    </div>
    <div>
      <p>林秀姿</p>
      <p v-for="(names, index) in alltext" :key="index">{{names}}</p>
      <p>許瑋琳、蘇韋豪、張心慈</p>
      <p>林冠宇、顏傑、張庭銓</p>
      <p>周融聖</p>
      <p>何振忠、錢欽青、林新輝</p>
      <p>施淑妙、應翠梅、林修全</p>
      <p>熊迺祺、蔡惠萍、魏忻忻</p>
      <p>吳貞瑩、唐秀麗、鄭朝陽</p>
      <p>潘如瑩、董谷音、許君吉</p>
      <p>陳易辰、蔣宗裕、彭素娟</p>
      <p>蕭宜君</p>
      <p>蕭衡倩、范凌嘉、王茂臻</p>
      <p>項國寧、羅國俊、游美月</p>
      <p>聯合報新聞部</p>
      <p>2021.09.01</p>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        text0: [],
        text1: [],
        text2: [],
      }
    },
    props: {
        text: { type: Array },
    },
    methods: {
      handleString(text, jobtitle) {
        if (this.hasHashMark(text)) {
          const re = /^.+#、(.+)/
          let str = text.match(re)[1]
          if(jobtitle === 'producer') this.text0.unshift(str)
          if(jobtitle === 'reporter') this.text1.unshift(str)
          if(jobtitle === 'image') this.text2.unshift(str)
          this.handleString(text.substring(0, text.length - str.length - 2), jobtitle)
        } else {
          if(jobtitle === 'producer') this.text0.unshift(text)
          if(jobtitle === 'reporter') this.text1.unshift(text)
          if(jobtitle === 'image') this.text2.unshift(text)
          return
        }
      },
      hasHashMark(text) {
        return text.indexOf("#") === -1 ? false : true
      }
    },
    computed:{
      alltext(){
          if(this.text!=undefined) {
            this.handleString(this.text[0], 'producer')
            this.handleString(this.text[1], 'reporter')
            this.handleString(this.text[2], 'image')
            return this.text0.concat(this.text1, this.text2)
          }
          else return "";
      },
      producerHeight(){
        return this.text0.length * 22 + 'px'
      },
      reporterHeight(){
        return this.text1.length * 22 + 'px'
      },
      imageHeight(){
        return this.text2.length * 22 + 'px'
      }
  },
  }
</script>

<style lang="scss" scoped>
  .container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 60px 0;
  }

  div {
    display: flex;
    flex-direction: column;
    & + & {
      margin-left: 20px;
    }
  }

  p {
    font-family: source-han-sans-traditional, sans-serif;
    font-weight:500;
    font-style: normal;
    text-align: left;
    font-size: 15px;
    color: #8B8B8B;
    padding: 0;
    line-height: 1.5;
  }

  .blank {
    height: 22px;
  }
</style>